import { BlockStack, Layout, Page } from '@shopify/polaris'
import ILayout from '@Types/ILayout'

function EmptyLayout({
  children,
  fullWidth = false,
  narrowWidth = true,
  ...props
}: ILayout): JSX.Element {
  return (
    <Page fullWidth={fullWidth} narrowWidth={narrowWidth} {...props}>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">{children}</BlockStack>
        </Layout.Section>
      </Layout>
    </Page>
  )
}

export default EmptyLayout
